var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.368,
    height: 59.649,
    viewBox: "0 0 58.368 59.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M355.741,135.582h-9.086a.866.866,0,1,0,0,1.733h9.086a.866.866,0,0,0,0-1.733Z",
    transform: "translate(-306.482 -119.919)",
    fill: "#0066cb",
    stroke: "#0066cb",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M356.607,174.171a.866.866,0,0,0-.866-.866h-9.086a.866.866,0,1,0,0,1.733h9.086A.866.866,0,0,0,356.607,174.171Z",
    transform: "translate(-306.482 -153.284)",
    fill: "#0066cb",
    stroke: "#0066cb",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M346.654,211.027a.866.866,0,0,0,0,1.733h6a.866.866,0,0,0,0-1.733Z",
    transform: "translate(-306.481 -186.648)",
    fill: "#0066cb",
    stroke: "#0066cb",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M62.2,230.115H57.3v-14.8a1.214,1.214,0,0,0-1.213-1.213H35.345v-2.644a.866.866,0,0,0-1.733,0V214.1H17.421V201.887h4.708v3.328a1.214,1.214,0,0,0,1.213,1.213h4.35a1.214,1.214,0,0,0,1.213-1.213v-3.328h4.708v5.527a.866.866,0,0,0,1.733,0v-6.047a1.214,1.214,0,0,0-1.213-1.213H16.9a1.214,1.214,0,0,0-1.213,1.213V214.1H12.866a1.214,1.214,0,0,0-1.213,1.213v14.8H6.758a1.214,1.214,0,0,0-1.213,1.213v3.639a1.214,1.214,0,0,0,1.213,1.213H62.2a1.214,1.214,0,0,0,1.213-1.213v-3.639A1.214,1.214,0,0,0,62.2,230.115ZM23.861,201.887h3.31V204.7h-3.31Zm21.959,13.947h3.31v2.808h-3.31Zm-22.248,0H27.46v2.808H23.573Zm-10.187,0H21.84v3.328a1.214,1.214,0,0,0,1.213,1.213H27.98a1.214,1.214,0,0,0,1.213-1.213v-3.328h8.454v14.281H13.386ZM61.68,234.447H7.278v-2.6H48.92a.866.866,0,1,0,0-1.733H39.38V215.834h4.708v3.328a1.214,1.214,0,0,0,1.213,1.213h4.35a1.214,1.214,0,0,0,1.213-1.213v-3.328h4.708v14.281H52.963a.866.866,0,1,0,0,1.733H61.68Z",
    transform: "translate(-5.545 -177.031)",
    fill: "#0066cb",
    stroke: "#0066cb",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M253.2,15.2V30.969a1.214,1.214,0,0,0,1.213,1.213h19.237a1.214,1.214,0,0,0,1.213-1.213V23.105a.866.866,0,0,0-1.733,0v7.344h-18.2V15.4h.006a7.678,7.678,0,0,0,5.545-2.365h8.09a.866.866,0,0,0,0-1.733h-6.832a7.652,7.652,0,0,0,.9-3.6c0-.247-.013-.492-.036-.733h10.525V19.062a.866.866,0,1,0,1.733,0V6.448a1.214,1.214,0,0,0-1.213-1.213H262.237A7.7,7.7,0,1,0,253.2,15.2Zm1.739-13.47A5.969,5.969,0,1,1,248.974,7.7,5.975,5.975,0,0,1,254.942,1.733Z",
    transform: "translate(-219.319)",
    fill: "#0066cb",
    stroke: "#0066cb",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M282.575,50.4a.867.867,0,0,0,1.225,0l3.524-3.523a.866.866,0,1,0-1.225-1.225l-2.911,2.911-2.042-2.042a.866.866,0,1,0-1.225,1.225Z",
    transform: "translate(-247.998 -40.153)",
    fill: "#0066cb",
    stroke: "#0066cb",
    strokeWidth: 0.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.8f8e78c09c17c35bf7bdabfdcef555fb.svg";
export { ForwardRef as ReactComponent };